/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GlobeEarthIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACI0lEQVR4nMVUPU9VQRB9lfiRiDyNhdhTmJj4A5RoxGzy7s7MK/bO8GGeGBv/gDHY2EnpT8DGTqG3M2g0hBqwUINag2gtZu7dy7sfcHe10E02udm7M2fmzNnT6fzP5ZzrAsldQFmxJJtA/FO3/14GSOd7vZmxv0l8AogfAfF3INlv2xZl1yIvaExU8n5/9iKgrIcSg26U1QMg4rVez42Hk5N8jUluib9pDEB6E0g+5t3wlyNBMlpiK6eMmifDwubOA/LbopPJweB4AyDnPK5yIFl0zh2rFdi1JNv5PX5Yr74bGqhF2TXGjLRRDJBeL+5W1JVJMThQXupELEv8zs/jzhAAZaWtckBecs6NxgAgTt/zVL4coqJs5YfyrA5gArQ0aZIrPtdmqS3Z08OpqblTFvlxGWDyMEW0LO3UA+w1AJIkOZl3VAWBSCXpIrp9tgngKQJwE8OzdhDI92IdwFq53KAoMy6SfR1Q5TLK05jXXIkhvu9t5EVpMOm8R31Vvpwk0+dCXdRFUPiTJRmUB9PN5Kg/+nKjGsAfAg/wByA/N2b2dEJ8C0h+WeIdxMGZamvICz5gSwGLc0S+ejCj1s3LgPzZ53hQp66jclSj8u29qT8sY8xInAny+yOlrVarlutBPgGk1yp0BY1QtgHkwqHJKyC+Ex/0WtVlrVwKVR5MXqZLLbcYfECqO8r5n1qK72ZmTF3RD3BDFeNVs6FmplJsqOVfr9+nMjcZQofqEAAAAABJRU5ErkJggg==)
 */
export const GlobeEarthIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-4.16 5.85A9 9 0 0 0 15 3.52V4a3 3 0 0 1-3 3h-.77c-.13 0-.23.1-.23.23A2.77 2.77 0 0 1 8.23 10c-.13 0-.23.1-.23.23v1.52c0 .14.11.25.25.25H13a3 3 0 0 1 3 3v.77c0 .13.1.23.23.23 1.2 0 2.23.77 2.61 1.85ZM3.18 10.18A9 9 0 0 0 11 20.94v-2.7c0-.14-.1-.24-.23-.24h-.65A2.12 2.12 0 0 1 8 15.88c0-.56-.22-1.1-.62-1.5l-4.2-4.2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
